import React from "react";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import { Img } from "react-image";
import { noImage } from "../../../resources/images";

function Overview({ description, compImage }) {
  return (
    <div className="overviewWrapper">
      <div className="popupTextarea comProfileImage">
        <Img src={[compImage , noImage]} />
      </div>
      <h2>Details</h2>

      <p>
        <FroalaEditorView model={description} />
      </p>
    </div>
  );
}

export default Overview;
